module.exports = __webpack_public_path__ + "favicon.ico";


/*****************
 ** WEBPACK FOOTER
 ** ./src/favicon.ico
 ** module id = 919
 ** module chunks = 9
 **/